import { render, staticRenderFns } from "./DialogGPT.vue?vue&type=template&id=606bdcfe&scoped=true"
import script from "./DialogGPT.vue?vue&type=script&lang=js"
export * from "./DialogGPT.vue?vue&type=script&lang=js"
import style0 from "./DialogGPT.vue?vue&type=style&index=0&id=606bdcfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606bdcfe",
  null
  
)

export default component.exports